import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { ApplicationStore, ProjectStore } from '@ffx/app-store';
import { catchError, map, of, tap } from 'rxjs';

export const memberGuard: CanActivateFn = (route, state) => {
    const projectStore = inject(ProjectStore);
    const appStore = inject(ApplicationStore);
    const router = inject(Router);

    const projectId = state.url.split('/')[1];
    const currentUserUid = appStore.user.uid();

    return projectStore.getDashboardProjectsByUserIdObservable(currentUserUid).pipe(
        map((dashboardProjects) =>
            dashboardProjects.some(
                (project) => project.id === projectId && (project.role === 'Member' || project.role === 'Owner')
            )
        ),
        tap((isProject) => {
            if (!isProject) {
                return router.navigate(['/']);
            }
            return of(true);
        }),
        catchError(() => {
            return router.navigate(['/']);
        })
    );
};
